import React, { Component } from 'react';
import DocMap from './doc/index';
import {
  getArray2Name,
  AppList,
  sensorsMonitor,
  changeIco,
  setAliasApp,
  getWhiteTime
} from '@/utils/utils';


const SaSdk = sensorsMonitor();
class InviteFriends extends Component {
  constructor(props) {
    super(props);
    const localApp = setAliasApp(props.match.params.app || 'kashway');
    let app = getArray2Name(AppList, localApp);
    if (!app) {
      app = AppList[0];
    }
    
    this.state = {
      localApp,
      appRules: app, // 当前app相关配置
    }
  }

  // 数据打点相关
  sensorsInit() {
    SaSdk.registerPage({
      current_url: window.location.href,
      pagename: 'permission',
      appName: this.state.appRules.appName,
    })

    SaSdk.quick('autoTrack');
    SaSdk.track('app_h5_privacy_policy_open', {
			load_time: getWhiteTime()
		});
    SaSdk.track('permission_open');
  }

  componentDidMount() {
    changeIco(this.state.localApp);
    this.sensorsInit();
  }

  render() {
    const { localApp } = this.state;
    const appClass = 'privacy-policy ' + localApp;
    
    let Doc = DocMap[localApp] || DocMap['kashway'];
    return <div className={ appClass }>
      <div className="doc" dangerouslySetInnerHTML={{ __html: Doc }}></div>
    </div>
  }
}

export default InviteFriends;
